<app-loading-bar />
<router-outlet />
<app-toast-host />
<app-confirm-dialog />
